export const GATES = {
  ASK_WHY_AUTOMATION: 'ask_why_automation',
  CARRY_FORWARD: 'carry_forward',
  COPY_A_SURVEY: 'copy_a_survey',
  CREATE_SURVEY_PEOPLE_GROUPS: 'create_survey_people_groups',
  INSTANT_SURVEY_AUTO_SAVE: 'auto_save_survey',
  INSTANT_SURVEY_MAINTENANCE: 'instant_survey_maintenance',
  MAXDIFF_PREFERENCE_ANALYSIS: 'maxdiff_preference_analysis',
  MULTIPLE_SUBSCRIPTIONS_REVAMP: 'multiple_subscriptions_revamp',
  MY_SURVEYS_SEPARATE_DRAFTS: 'my_surveys_separate_drafts',
  NARRATIVE_PUBLIC_SHARE: 'narrative_public_share',
  NARRATIVE_SHOPPER_ATTRIBUTES_PROMPT: 'narrative_shopper_attributes_prompt',
  PIPING_RESPONSES: 'piping_responses',
  PREVIEW_SURVEY: 'preview_survey',
  QUESTION_LIBRARY: 'question_library',
  QUESTION_TYPE_CONT_SUM: 'question_type_contsum',
  QUESTION_TYPE_MAX_DIFF: 'question_type_maxdiff',
  QUESTION_TYPE_NUMERIC: 'question_type_numeric',
  QUESTION_TYPE_VIDEO: 'video_survey',
  REAL_TIME_SAMPLE_VALIDATION: 'real_time_sample_validation',
  REQUIRE_QUESTION_TYPE_SELECTION: 'require_question_type_selection',
  RESEARCH_OBJECTIVES: 'research_objectives',
  RICH_TEXT_FORMATTING: 'rich_text_formatting',
  SCREENER_QUESTIONS: 'screener_questions',
  SEQUENTIAL_MONADIC: 'sequential_monadic',
  SORT_CHARTS: 'sort_charts',
  STANDARD_SURVEY: 'standard_survey',
  SURVEY_DASHBOARD_FULL_WIDTH: 'survey_dashboard_full_width',
  SURVEY_INCLUDE_DISQUALIFIED_RESPONSES: 'survey_include_disqualified_responses',
  SURVEY_TEMPLATES: 'survey_templates',
  TOP_2_BOX: 'top_2_box',
  USE_CALYPSO_AS_SURVEY_PROVIDER: 'use_calypso_as_survey_provider',
  WHOLE_SURVEY_SUMMARY: 'ai_overall_summary',
};
